import { useNavigate } from "react-router-dom";

import Button from "@/components/Button";
import { DASHBOARD_URL, LOGIN_MAIN_URL } from "@/constants/routes";
import useViewMode, { useViewModeStore } from "@/hooks/useViewMode";
import LoginLayout from "@/pages/Login/components/LoginLayout";
import useLoginStore from "@/store/loginStore";

const WaitContent = () => {
  const navigate = useNavigate();
  const { isViewAsUnapproved } = useViewMode();
  const { setViewMode } = useViewModeStore();
  const logout = useLoginStore(s => s.logout);

  return (
    <div className="flex flex-col items-center gap-6">
      {/* 아이콘 */}
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-amber-100">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>

      <div className="text-center">
        <h1 className="text-lg font-semibold text-gray-800">승인 대기 중</h1>
        <p className="mt-2 text-sm text-gray-500">
          회원가입 승인을 요청하였습니다.
        </p>
        <p className="text-sm text-gray-500">
          승인 완료까지 1~3일 소요될 수 있습니다.
        </p>
      </div>

      <div className="w-full rounded-lg border border-gray-100 bg-gray-50 px-4 py-3 text-center text-xs text-gray-400">
        문의: 목회지원실 (031-651-9680)
      </div>

      <Button
        onClick={() => {
          if (isViewAsUnapproved) {
            setViewMode("admin");
            navigate(DASHBOARD_URL);
          } else {
            // 카카오 토큰을 지우지 않으면 로그인 화면에서 다시 대기 화면으로 돌아온다
            logout();
            navigate(LOGIN_MAIN_URL);
          }
        }}
        variant="outlined"
        className="text-sm"
      >
        로그인 화면으로
      </Button>
    </div>
  );
};

const LoginWait = () => {
  const { isViewAsUnapproved } = useViewMode();

  if (isViewAsUnapproved) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <div className="w-full max-w-sm rounded-2xl border border-gray-200 bg-white px-8 py-12 shadow-lg">
          <WaitContent />
        </div>
      </div>
    );
  }

  return (
    <LoginLayout>
      <WaitContent />
    </LoginLayout>
  );
};

export default LoginWait;
